module.exports = __webpack_public_path__ + "9a0b7500b31a8c295f540c14cce416cb.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/poppins/Poppins-Bold.woff2
// module id = 1576
// module chunks = 0